<material-navbar
  [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')"
>
</material-navbar>

<ng-container
    *ngIf="paymentDetail$ | async as paymentDetail; else loadingSpinner"
>
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="card">
                    <!-- *ngIf="paymentDetail.subscription.status === 'completed'" -->
                    <mat-icon class="color-blue" svgIcon="check"></mat-icon>
                    <h1>Payment Successful</h1>
                    <div class="user-details">
                        <h3>Thank you for your purchase. Your plan has been changed!</h3>
                        <!-- <p class="user-name">{{ paymentDetail.customer.first_name+" "+paymentDetail.customer.last_name }}</p> -->
                        <p class="user-email"
                            *ngIf="paymentDetail.customer.email"
                        >
                            {{ paymentDetail.customer.email }}
                        </p>
                    </div>
                    <h2>Payment Amount</h2>
                    <p class="amount">
                        {{ paymentDetail.invoice.currency }} 
                        <ng-container
                            *ngIf="paymentDetail.invoice.currency === 'JPY'; else otherCurrency"
                        >
                            {{ paymentDetail.invoice.amount }}
                        </ng-container>
                        <ng-template
                            #otherCurrency
                        >
                            {{ (paymentDetail.invoice.amount / 100).toFixed(2) }}
                        </ng-template>
                    </p>
                    <ng-template
                        *ngIf="paymentDetail.subscription.payment_method"
                    >
                        <div class="payment-method">
                            <h3>Payment Method</h3>
                        </div>
                        <div class="payment-info">
                            <p class="card-type">{{ paymentDetail.subscription.payment_method }}</p>
                        </div>
                    </ng-template>
                    <a href="/dashboard" class="btn">Go To Dashboard</a>
                </div>
                <!-- <div class="card"
                    *ngIf="paymentDetail.subscription.status === 'processing'"
                >
                    <mat-icon class="color-red" svgIcon="warning"></mat-icon>
                    <h1>Payment Processing</h1>
                    <div class="user-details">
                        <h3>We'll update you when payment is received</h3>
                        <p class="user-name">{{ paymentDetail.customer.first_name+" "+paymentDetail.customer.last_name }}</p>
                        <p class="user-email"
                            *ngIf="paymentDetail.customer.email"
                        >
                            {{ paymentDetail.customer.email }}
                        </p>
                    </div>
                    <h2>Payment Amount</h2>
                    <p class="amount">
                        {{ paymentDetail.plan.item.currency }} 
                        <ng-container
                            *ngIf="paymentDetail.currency === 'JPY'; else otherCurrency"
                        >
                            {{ paymentDetail.plan.item.amount }}
                        </ng-container>
                        <ng-template
                            #otherCurrency
                        >
                            {{ (paymentDetail.plan.item.amount / 100).toFixed(2) }}
                        </ng-template>
                    </p>
                    <ng-template
                        *ngIf="paymentDetail.subscription.payment_method"
                    >
                        <div class="payment-method">
                            <h3>Payment Method</h3>
                        </div>
                        <div class="payment-info">
                            <p class="card-type">{{ paymentDetail.subscription.payment_method }}</p>
                        </div>
                    </ng-template>
                    <a href="/dashboard" class="btn">Go To Dashboard</a>
                </div>
                <div class="card"
                    *ngIf="paymentDetail.status === 'requires_payment_method'"
                >
                    <mat-icon class="color-red" svgIcon="cancel"></mat-icon>
                    <h1>Payment Failed</h1>
                    <div class="user-details">
                        <h3>Please try another payment method</h3>
                        <p class="user-email"
                            *ngIf="paymentDetail.receipt_email"
                        >
                            {{ paymentDetail.receipt_email }}
                        </p>
                    </div>
                    <a class="btn"
                        routerLink="/billing/pricing"
                    >
                        Retry Payment
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loadingSpinner>
    <loading-indicator
    [isVisible]="true"
    class="overlay"
    ></loading-indicator>
</ng-template>